// this is an autogenerated file from DesignSystem/LetterRecipientPicker/Trigger/query-get-person-by-id.graphql
import { gql } from 'Data/Api'

export default gql`
query app__DesignSystem_LetterRecipientPicker_Trigger($_id: uuid!) {
  vaxiom_persons(where: { _id: { _eq: $_id } }, limit: 1) {
    id
    _id
    first_name
    last_name
  }
}

`